export const AccessLevel = Object.freeze({
  PUBLIC: "PUBLIC",
  ORGANISATION: "ORGANISATION",
  GROUP: "GROUP",
  PRIVATE: "PRIVATE",
  GUEST: "GUEST",
  PERSONAL: "PERSONAL",
});

export const CheckInMode = Object.freeze({
  BARCODE: "BARCODE",
  MANUAL: "MANUAL",
});

export const CartSource = Object.freeze({
  BACKSTORE: "BACKSTORE",
  SHOP: "SHOP",
  MARKETPLACE: "MARKETPLACE",
});

export const CollectionType = Object.freeze({
  SINGLE: "SINGLE",
  INVOICE: "INVOICE",
  INSTANT: "INSTANT",
  ADMIN_INSTANT: "ADMIN_INSTANT",
  CART: "CART",
  MANUAL: "MANUAL",
  DUES: "DUES",
  DONATION: "DONATION",
});

export const CollectionStatus = Object.freeze({
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  CLOSED: "CLOSED",
  PAUSED: "PAUSED",
  DECOMMISSIONED: "DECOMMISSIONED",
  CANCELLED: "CANCELLED",
});

export const DeliveryMode = Object.freeze({
  INSTORE: "INSTORE",
  PICKUP: "PICKUP",
  LOCATION: "LOCATION",
});

export const DeliveryStatus = Object.freeze({
  NOT_TRACKING: "NOT_TRACKING",
  PROCESSING: "PROCESSING",
  CONFIRMED: "CONFIRMED",
  READY: "READY",
  PICKED_UP: "PICKED_UP",
  EN_ROUTE: "EN_ROUTE",
  AT_DESTINATION: "AT_DESTINATION",
  DELIVERED: "DELIVERED",
  BOOKING: "BOOKING",
  RETURNED: "RETURNED",
  CANCELLED: "CANCELLED",
  INDIVIDUAL_TRACKING: "INDIVIDUAL_TRACKING",
  MISSING: "MISSING",
  DAMAGED: "DAMAGED",
});

export const DiscountSource = Object.freeze({
  NONE: "NONE",
  MEMBERSHIP: "MEMBERSHIP",
  MANUAL: "MANUAL",
});

export const DiscountType = Object.freeze({
  AMOUNT: "AMOUNT",
  PERCENTAGE: "PERCENTAGE",
  NONE: "NONE",
});

export const DisplayPriceOption = Object.freeze({
  NORMAL: "NORMAL",
  DISCOUNT: "DISCOUNT",
  PROMO: "PROMO",
  MARKUP: "MARKUP",
});

export const FundLocation = Object.freeze({
  ORGANISATION: "ORGANISATION",
  GROUP: "GROUP",
  DEDICATED: "DEDICATED",
});

export const InvoiceLogoOption = Object.freeze({
  COMMUNITY_LOGO: "COMMUNITY_LOGO",
  UPLOAD: "UPLOAD",
  NO_LOGO: "NO_LOGO",
});

export const InvoiceOwnerType = Object.freeze({
  GUEST: "GUEST",
  MEMBER: "MEMBER",
});

export const InvoiceTemplate = Object.freeze({
  DEFAULT: "DEFAULT",
  CONVERTI: "CONVERTI",
});

export const InvoiceType = Object.freeze({
  STANDARD: "STANDARD",
  CASH: "CASH",
});

export const MemberStatus = Object.freeze({
  ACTIVE: "ACTIVE",
  REQUEST: "REQUEST",
  LEAVE: "LEAVE",
  UNLINK: "UNLINK",
  REMOVE: "REMOVE",
  WITHDRAW: "WITHDRAW",
  DECLINE: "DECLINE",
  DEPENDANT: "DEPENDANT",
});

export const MemberType = Object.freeze({
  ADMIN: "ADMIN",
  OWNER: "OWNER",
  MEMBER: "MEMBER",
});

export const OfflinePaymentMode = Object.freeze({
  CASH: "CASH",
  BANK_TRANSFER: "BANK_TRANSFER",
  CARD: "CARD",
  DISCOUNT: "DISCOUNT",
  INFLOW: "INFLOW",
});

export const OrderSource = Object.freeze({
  PHYSICAL_OUTLET: "PHYSICAL_OUTLET",
  CIRCLEPLUG: "CIRCLEPLUG",
  REFERRAL: "REFERRAL",
  FRIENDS: "FRIENDS",
  WHATSAPP: "WHATSAPP",
  INSTAGRAM: "INSTAGRAM",
  TIKTOK: "TIKTOK",
  FACEBOOK: "FACEBOOK",
  X: "X",
  LINKEDIN: "LINKEDIN",
  WEB_SITE: "WEB_SITE",
  EMAIL: "EMAIL",
  PHONE_CALL: "PHONE_CALL",
  OTHERS: "OTHERS",
});

export const OrgStatus = Object.freeze({
  ACTIVE: "ACTIVE",
  APPROVED: "APPROVED",
  PENDING: "PENDING",
  CANCELLED: "CANCELLED",
  INACTIVE: "INACTIVE",
  DECLINED: "DECLINED",
});

export const PaymentGateWay = Object.freeze({
  PAYSTACK: "PAYSTACK",
  WALLET: "WALLET",
});

export const PaymentStatus = Object.freeze({
  PENDING: "PENDING",
  PAID: "PAID",
  CANCELLED: "CANCELLED",
  PARTIAL: "PARTIAL",
  GENERAL: "GENERAL",
  REVIEW: "REVIEW",
  EXCESS_PAYMENT: "EXCESS_PAYMENT",
});

export const EventStatus = Object.freeze({
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  CLOSED: "CLOSED",
  DECOMMISSIONED: "DECOMMISSIONED",
});

export const MediaType = Object.freeze({
  IMAGE: "image",
  VIDEO: "video",
  AUDIO: "audio",
  FILE: "file",
});

export const PollStatus = Object.freeze({
  ACTIVE: "ACTIVE",
  CLOSE: "CLOSE",
  PUBLISH: "PUBLISH",
  INACTIVE: "INACTIVE",
  CANCELLED: "CANCELLED",
  DECOMMISSIONED: "DECOMMISSIONED",
});

export const ProductNode = Object.freeze({
  CHILD: "CHILD",
  PARENT: "PARENT",
});

export const ProductStatus = Object.freeze({
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  DEACTIVATED: "DEACTIVATED",
  DECOMMISSIONED: "DECOMMISSIONED",
});

export const ProfileType = Object.freeze({
  individual: "individual",
  organisation: "organisation",
});

export const RequestType = Object.freeze({
  USER: "USER",
  MEMBER: "MEMBER",
  ORGANISATION: "ORGANISATION",
});

export const SearchBarOption = Object.freeze({
  BARCODE_SCANNER: "BARCODE_SCANNER",
  SEARCH_INPUT: "SEARCH_INPUT",
});

export const WeightType = Object.freeze({
  DIRECT: "DIRECT",
  SHARED: "SHARED",
  NONE: "NONE",
});

export const WeightUnit = Object.freeze({
  KG: "kg",
  G: "g",
  MG: "mg",
  LB: "lb",
  OZ: "oz",
  NONE: "none",
});

export const enumValue = (enumObject, value) => {
  if (value === null || value === undefined) return undefined;
  const normalized = String(value);
  if (Object.values(enumObject).includes(normalized)) return normalized;

  const upperValue = normalized.toUpperCase();
  if (Object.prototype.hasOwnProperty.call(enumObject, upperValue)) {
    return enumObject[upperValue];
  }

  return Object.values(enumObject).find(
    (enumItem) => String(enumItem).toUpperCase() === upperValue,
  );
};
